<template>
  <v-list three-line class="mb-2 mt-0 pt-0">
      <v-tooltip right :disabled="!miniVariant">
          <v-list-tile exact slot="activator" class="mb-2 pb-2">
              <v-list-tile-avatar>
                  <v-icon color="blue" x-large>mdi-weather-partlycloudy</v-icon>
              </v-list-tile-avatar>
              <v-list-tile-content>
                  <v-list-tile-title>Plan Gratis</v-list-tile-title>
                  <v-list-tile-sub-title class="caption">Gratis hasta que tu negocio sea negocio</v-list-tile-sub-title>
              </v-list-tile-content>
          </v-list-tile>
              </v-list-tile-content>
          </v-list-tile>
          <span>Plan Gratis</span>
      </v-tooltip>
  </v-list>
</template>
<script>
export default {
    props: ['miniVariant']
}
</script>